import classNames from 'classnames';
import { Content, isFilled } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { Box, Wrapper } from '@preventx/oxygen';

// Services
import { wrapperSize } from '@/services/utils/box';

// Components
import { WithHowRegion } from '@/slices/shared/RegionComplex/WithHowRegion';
import { WithSupportFAQs } from '@/slices/shared/RegionComplex/WithSupportFAQs';
import { DefaultStructure } from '@/slices/shared/RegionComplex/DefaultStructure';
import { WithPrivateRegion } from '@/slices/shared/RegionComplex/WithPrivateRegion';
import { WithGuidesSupport } from '@/slices/shared/RegionComplex/WithGuidesSupport';
import { WithPriorityService } from '@/slices/shared/RegionComplex/WithPriorityService';
import { WithFrequentlyAskedQuestions } from '@/slices/shared/RegionComplex/WithFrequentlyAskedQuestions';

export type RegionComplexProps =
  SliceComponentProps<Content.RegionComplexSlice>;

const RegionComplex = ({ slice }: RegionComplexProps) => {
  const { id, primary, variation } = slice;

  if (!primary) {
    return null;
  }

  const { identifier, override_padding, wrapper_size } = primary;

  return (
    <Box
      component="section"
      addRegion={variation !== 'default'}
      id={isFilled.keyText(identifier) ? identifier : undefined}
      className={classNames({
        'region--how': variation === 'withHowRegion',
        'region--private': variation === 'withPrivateRegion',
        'region--priority': variation === 'withPriorityService',

        'bg-primary': variation === 'withGuidesAndSupport',

        'pt-0': override_padding === 'No Padding - Top',
        'pb-0': override_padding === 'No Padding - Bottom',
        'py-0': override_padding === 'No Padding - Top Bottom',

        'region--faq':
          variation === 'withFaqs' || variation === 'withSimpleFaqsAndReviewer',
      })}
    >
      <Wrapper size={wrapperSize(wrapper_size)}>
        {variation === 'default' && <DefaultStructure id={id} slice={slice} />}

        {variation === 'withPriorityService' && (
          <WithPriorityService slice={slice} />
        )}

        {variation === 'withHowRegion' && (
          <WithHowRegion id={id} slice={slice} />
        )}

        {variation === 'withPrivateRegion' && (
          <WithPrivateRegion id={id} slice={slice} />
        )}

        {variation === 'withFaqs' && (
          <WithFrequentlyAskedQuestions id={id} slice={slice} />
        )}

        {variation === 'withSimpleFaqsAndReviewer' && (
          <WithSupportFAQs id={id} slice={slice} />
        )}

        {variation === 'withGuidesAndSupport' && (
          <WithGuidesSupport id={id} slice={slice} />
        )}
      </Wrapper>
    </Box>
  );
};

export default RegionComplex;
